module.exports = __webpack_public_path__ + "static/media/audioControl copy.bc32ab0c.bin";